export default __webpack_public_path__ + "static/media/T5WInfographics4.bf74e44e4adc2d23665206b6524a1253.png";